import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

import { TitleService } from '../../shared/services/title.service';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
})
export class GlobalComponent implements OnInit {
  public activeTabId: string = 'structures';

  constructor(private readonly titleService: TitleService, private readonly route: ActivatedRoute, private readonly router: Router) {}

  public ngOnInit(): void {
    this.titleService.setTitle('Administration');
    if (this.route.snapshot.paramMap.has('tab')) {
      this.activeTabId = this.route.snapshot.paramMap.get('tab');
    }
  }

  public onNavChange(event: NgbNavChangeEvent): void {
    this.router.navigate(['/admin', event.nextId]);
  }
}
